import { AUTH_SERVICE_URL } from '../BaseUrls';

function ConferenceToken(core) {
    this.client = core.client;
}

const baseUrl = `${AUTH_SERVICE_URL}/api/v2/Token/Conference/`;

Object.assign(ConferenceToken.prototype, {
    namespace: 'ConferenceToken',
    get(params, headers) {
        return this.client.send('GET', baseUrl, params, headers);
    }
});

export default ConferenceToken;
